import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, FileTextIcon, CalculatorIcon, MessageCircleIcon } from 'lucide-react';
const badges = [{
  icon: ShieldCheckIcon,
  text: 'Garantía 5 años'
}, {
  icon: FileTextIcon,
  text: 'Contrato notarial'
}, {
  icon: CalculatorIcon,
  text: 'Presupuesto gratis'
}, {
  icon: MessageCircleIcon,
  text: 'WhatsApp directo'
}];
export function Trust() {
  return <section className="py-20 bg-concrete" data-id="element-146">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="max-w-4xl mx-auto text-center" data-id="element-148">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-149">
            Construir con respaldo cambia todo
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-gray-600 leading-relaxed mb-12" data-id="element-150">
            Una construcción no solo debe verse bien. También debe entregar
            seguridad, claridad y confianza. Por eso destacamos nuestras
            garantías, contratos formales y presupuestos gratuitos desde el
            primer contacto.
          </motion.p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-151">
            {badges.map((badge, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-3 bg-white px-6 py-4 rounded-full shadow-sm border border-gray-100" data-id="element-152">
                <badge.icon className="w-6 h-6 text-orange" data-id="element-153" />
                <span className="font-semibold text-navy" data-id="element-154">{badge.text}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}